var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trailing-icon",
    clipPath: "url(#rateIcon)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.1495 9.35507L14.6253 8.94445L12.8586 4.59392C12.5408 3.80203 11.4565 3.80203 11.1387 4.59392L9.37198 8.95423L4.85713 9.35507C4.03455 9.4235 3.69804 10.4989 4.32432 11.0659L7.75486 14.1749L6.72663 18.7894C6.53968 19.6301 7.409 20.2949 8.11941 19.8452L11.9986 17.4011L15.8779 19.855C16.5883 20.3047 17.4576 19.6399 17.2706 18.7991L16.2424 14.1749L19.6729 11.0659C20.2992 10.4989 19.9721 9.4235 19.1495 9.35507V9.35507ZM11.9986 15.5729L8.48396 17.7922L9.41872 13.6078L6.31534 10.7922L10.4096 10.4207L11.9986 6.48078L13.5971 10.4305L17.6913 10.802L14.5879 13.6176L15.5226 17.8019L11.9986 15.5729Z",
    fill: "#295BB7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "rateIcon"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRateIcon);
export default __webpack_public_path__ + "static/media/rateIcon.9b1d9a3148a6c2582655c0676c6f09ee.svg";
export { ForwardRef as ReactComponent };